import { render, staticRenderFns } from "./credit-line-dispatchings.vue?vue&type=template&id=4684c063"
import script from "./credit-line-dispatchings.vue?vue&type=script&lang=ts"
export * from "./credit-line-dispatchings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports